import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'

import {Button} from 'antd'

import {NotFound} from 'pages/NotFound.jsx'
import {DeviceService} from 'api/device'

import {Form, Submit, Reset} from 'forms'

import {Activity} from './Activity.jsx'
import {Definition} from './Definition.jsx'
import {Info} from './Info.jsx'

export class Overview extends React.Component {
   static get propTypes() {
      return {
         network:  React.PropTypes.object,
         device:   React.PropTypes.object,
         messages: React.PropTypes.array,
         router:   React.PropTypes.object,
         location: React.PropTypes.object
      }
   }

   constructor() {
      super()

      this.state = {}

      this.handleSubmit = this.handleSubmit.bind(this)
   }

   handleSubmit(ev, patch) {
      ev.preventDefault()

      const nid = this.props.network.key,
         key = this.props.device.key

      return DeviceService.update(nid, key, patch)
   }

   render() {
      const {device, network, messages, router, location} = this.props

      if (!device || !network) {
         return <NotFound />
      }

      return (
         <div className="device">
            <Form
               onSubmit={this.handleSubmit}
               transform={input => _.omit(input, (v, k) => k.match(/^\$/))}
               input={device}
            >

               <Form.Updated>Device was successfully updated</Form.Updated>
               <Form.Error>Some error occurred during submit</Form.Error>

               <Row>
                  <Col md={6}>
                     <Definition network={network} device={device} />

                     <div className="text-right">
                        <Button.Group style={{clear: 'both'}}>
                           <Reset>Reset Form</Reset>
                           <Submit>Update Device</Submit>
                        </Button.Group>
                     </div>
                  </Col>

                  <Col md={6}>
                     <Info network={network} device={device} />
                  </Col>
               </Row>
            </Form>

            <Row>
               <Col xs={12}>
                  <Activity
                     location={location}
                     router={router}
                     messages={messages}
                     network={network}
                     device={device}
                  />
               </Col>
            </Row>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/overview/index.jsx